export const trativeFormatDateWithIdiom = (idiom: string | null): string => {
  const idiomInLowerCase = idiom?.toLowerCase();

  if (idiomInLowerCase === 'en_us') {
    return 'DD/MM/yyyy';
  }
  return 'DD/MM/yyyy';
};
